import React from 'react'
import {Icon} from '@chakra-ui/react'

const OthersIcon = (props) => {
    return (
        <Icon viewBox="0 0 24 24" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 22.4C17.7438 22.4 22.4 17.7438 22.4 12C22.4 6.25624 17.7438 1.6 12 1.6C6.25624 1.6 1.6 6.25624 1.6 12C1.6 17.7438 6.25624 22.4 12 22.4ZM12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
                fill="currentColor"
            />
            <circle cx="11.9998" cy="12.0001" r="1.33333" fill="currentColor" />
            <circle cx="17.3333" cy="12.0001" r="1.33333" fill="currentColor" />
            <circle cx="6.66683" cy="12.0001" r="1.33333" fill="currentColor" />
        </Icon>
    )
}

export default OthersIcon
